import '../../../scss/app/product_category.scss'
import { BP_LARGE_MAX } from '../../shared/stylesheet/Breakpoints'
import { breakpoints } from '../breakpoints'

//
// Filters
//

const lessThanLargeMq = window.matchMedia(`screen and ${breakpoints[BP_LARGE_MAX].toMediaCondition()}`)
const filtersToggle = document.querySelector('.product-category-filters__toggle')

function filtersMediaQueryHandler(ev) {
  if (!filtersToggle) {
    return
  }
  if (ev.matches) {
    filtersToggle.removeAttribute('open')
  } else {
    filtersToggle.setAttribute('open', 'open')
  }
}

if (filtersToggle) {
  lessThanLargeMq.addEventListener('change', filtersMediaQueryHandler)
  filtersMediaQueryHandler(lessThanLargeMq)
}

//
// Order By
//

const orderByInput = document.getElementById('js-order-by')
if (orderByInput) {
  orderByInput.addEventListener('change', (ev) => {
    document.location.href = ev.target.value
  })
}
